import { render, staticRenderFns } from "./LoadingCategoriasSlider.vue?vue&type=template&id=2f9e22bd&scoped=true"
import script from "./LoadingCategoriasSlider.vue?vue&type=script&lang=js"
export * from "./LoadingCategoriasSlider.vue?vue&type=script&lang=js"
import style0 from "./LoadingCategoriasSlider.vue?vue&type=style&index=0&id=2f9e22bd&prod&lang=scss"
import style1 from "./LoadingCategoriasSlider.vue?vue&type=style&index=1&id=2f9e22bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9e22bd",
  null
  
)

export default component.exports